import React from 'react';
import { CheckIcon } from 'lucide-react';
import { insideItems } from '../data/content';
export function LookInside() {
  return <section className="w-full bg-slate-950 px-5 py-12 text-white sm:py-16" data-id="element-126" data-mp="2fma30qmanljn">
      <div className="mx-auto max-w-[1000px] text-center" data-id="element-127" data-mp="21nsmbcut39b8">
        <h2 className="text-balance text-[1.6rem] font-extrabold uppercase leading-[0.95] tracking-tight sm:text-[2rem]" data-id="element-128" data-mp="25om7hygv6a0f">
          See What’s Actually Inside{' '}
          <span className="text-orange-500" data-id="element-129" data-mp="1rvmvi6gaixxm">FINANCIAL LITERACY READY™</span>
        </h2>
        <p className="mt-4 text-[1.05rem] font-bold text-white" data-id="element-130" data-mp="1wopoacd8u3cr">
          This is not theory.
        </p>
        <p className="mt-1 text-[1rem] leading-relaxed text-white/90" data-id="element-131" data-mp="1i0mhx1vagpnf">
          The resources are designed for the classroom.
        </p>

        <p className="mt-7 text-[0.8rem] font-bold uppercase tracking-[0.2em] text-white/80" data-id="element-132" data-mp="18yd70aw3yu9i">
          You’ll find:
        </p>
        <ul className="mx-auto mt-4 grid gap-x-6 gap-y-3 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-133" data-mp="1dxpvt16jibeq">
          {insideItems.map(item => <li key={item} className="flex items-center gap-3 border-b border-slate-800 pb-3 text-[1rem] text-white" data-id="element-134" data-mp="a0uy7ch87j9e">
              <CheckIcon className="h-4 w-4 shrink-0 text-orange-500" strokeWidth={3} aria-hidden="true" data-id="element-135" data-mp="k13xx0affmtj" />
              {item}
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-[620px] text-[1rem] font-extrabold uppercase leading-tight tracking-tight text-orange-500 sm:text-[1.15rem]" data-id="element-136" data-mp="3ni41bntdv9ay">
          Everything is designed so you can spend less time preparing and more
          time teaching.
        </p>
      </div>
    </section>;
}